/**
 * Gets corresponding index for serial number from table.
 *
 * @param props : props passed to Cell in table
 * @param pageSize : current size of page
 * @param pageData : data fetched from meta for page
 *
 * @returns */
export function getIndexOfSN(props: { index: number }, pageSize: number, pageData: { page: number }): number {
  const index = props.index + 1 + pageSize * (pageData.page - 1);

  return index;
}
